import { render, staticRenderFns } from "./OrderGenerationDetails.vue?vue&type=template&id=31755038&scoped=true&lang=pug"
import script from "./OrderGenerationDetails.vue?vue&type=script&lang=js"
export * from "./OrderGenerationDetails.vue?vue&type=script&lang=js"
import style0 from "./OrderGenerationDetails.vue?vue&type=style&index=0&id=31755038&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31755038",
  null
  
)

export default component.exports